import { ClassUtils } from "../../utils/ClassUtils";
import { ColorUtils } from "../../utils/ColorUtils";
import { Pool } from "../../utils/Pool";
import { VertexStream } from "../../utils/VertexStream";
import { Rectangle } from "../../maths/Rectangle";
import { Config } from "../../../Config";
import { UVClippingUtils } from "../../webgl/utils/UVClippingUtils";
import { drawTrianglesBatched } from "./DrawTrianglesBatchHelper";
const className = "DrawTrianglesCmd";
export class DrawTrianglesCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this._dynamic = null;
        this._tempUVs = null;
    }
    static create(texture, x, y, vertices, uvs, indices, matrix, alpha, color, blendMode) {
        var _a;
        var cmd = Pool.getItemByClass(className, DrawTrianglesCmd);
        cmd.texture = texture;
        texture === null || texture === void 0 ? void 0 : texture._addReference();
        cmd.x = x;
        cmd.y = y;
        cmd.vertices = vertices;
        cmd.uvs = uvs;
        cmd.indices = indices;
        cmd.matrix = matrix;
        cmd.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        cmd.blendMode = blendMode;
        cmd._dynamic = (_a = texture === null || texture === void 0 ? void 0 : texture._dynamic) === null || _a === void 0 ? void 0 : _a.uv;
        return cmd;
    }
    static create2(texture, mesh, color) {
        var _a;
        var cmd = Pool.getItemByClass(className, DrawTrianglesCmd);
        cmd.texture = texture;
        texture === null || texture === void 0 ? void 0 : texture._addReference();
        cmd.x = 0;
        cmd.y = 0;
        cmd.mesh = mesh;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        cmd._dynamic = (_a = texture._dynamic) === null || _a === void 0 ? void 0 : _a.uv;
        return cmd;
    }
    recover() {
        var _a;
        (_a = this.texture) === null || _a === void 0 ? void 0 : _a._removeReference();
        this.texture = null;
        this.vertices = null;
        this.uvs = null;
        this.indices = null;
        this.matrix = null;
        this.mesh = null;
        this.colors = null;
        this._cacheData = null;
        this._dynamic = null;
        this._tempUVs = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        var _a;
        if (this.mesh) {
            let vb = VertexStream.pool.take(this.texture);
            vb.contentRect.setTo(0, 0, runner.sprite.width, runner.sprite.height);
            if (this.color)
                vb.color.setABGR(this.color);
            try {
                this.mesh.onPopulateMesh(vb);
            }
            catch (e) {
                console.error(e);
            }
            if ((_a = this.texture) === null || _a === void 0 ? void 0 : _a.uvrect) {
                if (Config.uvClipMode === "cpu") {
                    const clippedData = UVClippingUtils.clipTrianglesByUVRange(vb.getVertices(), vb.getIndices(), vb.getUVs(), this.texture.uvrect, vb.getColors());
                    drawTrianglesBatched(runner, this.texture, this.x + gx, this.y + gy, clippedData.vertices, clippedData.uvs, clippedData.indices, this.matrix, this.alpha, this.blendMode, null, clippedData.colors, null);
                }
                else {
                    drawTrianglesBatched(runner, this.texture, this.x + gx, this.y + gy, vb.getVertices(), vb.getUVs(), vb.getIndices(), this.matrix, this.alpha, this.blendMode, null, vb.getColors(), this.texture.uvrect);
                }
            }
            else {
                drawTrianglesBatched(runner, this.texture, this.x + gx, this.y + gy, vb.getVertices(), vb.getUVs(), vb.getIndices(), this.matrix, this.alpha, this.blendMode, null, vb.getColors(), null);
            }
            VertexStream.pool.recover(vb);
        }
        else if (this.vertices && this.uvs && this.indices) {
            drawTrianglesBatched(runner, this.texture, this.x + gx, this.y + gy, this.vertices, this.uvs, this.indices, this.matrix, this.alpha, this.blendMode, this.color, this.colors, null);
        }
    }
    get cmdID() {
        return DrawTrianglesCmd.ID;
    }
    getBounds(assembler) {
        Rectangle.TEMP.setTo(0, 0, assembler.width, assembler.height).getBoundPoints(assembler.points);
    }
}
DrawTrianglesCmd.ID = className;
ClassUtils.regClass(className, DrawTrianglesCmd);
